import { ListTodo } from 'lucide-react'
import { Cell } from '@highlight/ui'

export interface ReminderCellProps {
  reminder: {
    id: string
    text: string
    type: 'task' | 'note'
    dueAt?: string | null
    source?: { type: string; id: string; title?: string } | null
  }
  view?: {
    name: string
    icons: Array<string>
  }
  onClick?: (reminderId: string) => void
}

function formatDueAt(dueAt: string): string {
  try {
    const date = new Date(dueAt)
    const now = new Date()
    const isToday = date.toDateString() === now.toDateString()
    const isTomorrow = date.toDateString() === new Date(now.getTime() + 86400000).toDateString()

    if (isToday) {
      return `Today at ${date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`
    }
    if (isTomorrow) {
      return `Tomorrow at ${date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`
    }
    return date.toLocaleDateString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
  } catch {
    return dueAt
  }
}

export function ReminderCell({ reminder, view, onClick }: ReminderCellProps) {
  const iconUrl = view?.icons?.[0]

  return (
    <Cell onClick={() => onClick?.(reminder.id)}>
      <Cell.Header className="min-w-0">
        <Cell.Icon className="self-start">
          {iconUrl ? <img src={iconUrl} alt="" className="size-3.5 rounded-md object-contain" /> : <ListTodo />}
        </Cell.Icon>
        <div className="flex min-w-0 flex-1 flex-col">
          <Cell.Title className="text-foreground">{reminder.text}</Cell.Title>
          {reminder.dueAt && (
            <span className="text-foreground-placeholder truncate text-xs tabular-nums">
              {formatDueAt(reminder.dueAt)}
            </span>
          )}
        </div>
      </Cell.Header>
    </Cell>
  )
}
